import React from "react";
import { Box, Typography, Grid, Paper } from "@mui/material";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import EditIcon from "@mui/icons-material/Edit";

// const salesData = [
//   { label: "Total Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Counter Sale", today: "0.00", monthly: "77801.95" },
//   { label: "Credit Sale", today: "0.00", monthly: "0.00" },
//   { label: "Expenses", today: "0.00", monthly: "14000.00" },
//   { label: "Number of Bills", today: "0", monthly: "38" },
//   { label: "Product Sold", today: "0", monthly: "58" },
//   { label: "Service Sold", today: "0", monthly: "26" },
// ];

const TableReport = ({ salesData, colName, data, setModalData, setOpen }) => {
  return (
    <Box
      sx={{
        py: "20px",
        px: { xs: "10px", sm: "50px" },
        background: "white",
        borderRadius: "10px",
        marginBottom: "30px",
      }}
    >
      <Grid container spacing={1} sx={{}}>
        <Grid
          container
          spacing={1}
          sx={{
            borderBottom: "1px solid #1E1E1E",
            padding: "10px 40px",
          }}
        >
          <Grid item xs={5}>
            <Typography
              align="left"
              color="primary"
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Product Name
            </Typography>
          </Grid>
          <Grid item xs={3}>
            <Typography
              color="primary"
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Alert Value
            </Typography>
          </Grid>
          <Grid item xs={2}>
            <Typography
              color="primary"
              sx={{
                fontFamily: "'Montserrat', sans-serif",
                fontWeight: 500,
                fontSize: { xs: "12px", sm: "13px", md: "15px" },
              }}
            >
              Available
            </Typography>
          </Grid>
        </Grid>

        {/* Header */}

        <Grid
          container
          sx={{
            height: "50vh",
            overflow: "auto",
            paddingRight: { xs: "1px", sm: "10px" },
          }}
        >
          {/* Data Rows */}
          {data.map((item, idx) => (
            <Grid
              container
              key={idx}
              elevation={2}
              sx={{
                borderRadius: "10px",
                my: "5px",
                background: "#E3E3FF",
                color:
                  item?.totalItemQuantity < item?.inventoryAlarmValue
                    ? "red"
                    : "initial",
                px: { xs: "30px", sm: "40px" },
              }}
            >
              <Grid item xs={5}>
                <Box p={1}>
                  <Typography
                    sx={{
                      // textAlign: "center",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    fontWeight={500}
                  >
                    {item?.description}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3} pr={{ xs: 0, sm: 2, md:6, lg:20 }}>
                <Box p={1}>
                  <Typography
                    sx={{
                      textAlign: "right",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    fontWeight={500}
                  >
                    {item?.inventoryAlarmValue}
                  </Typography>
                </Box>
              </Grid>
              <Grid item xs={3} pr={{ xs: 0, sm: 2, md:8, lg:20 }}>
                <Box p={1}>
                  <Typography
                    sx={{
                      textAlign: "right",
                      fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    }}
                    fontWeight={500}
                  >
                    {item?.totalItemQuantity}
                  </Typography>
                </Box>
              </Grid>
              <Grid
                item
                xs={1}
                pl={2}
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <EditIcon
                  sx={{
                    cursor: "pointer",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                  }}
                  onClick={() => {
                    setOpen(true);
                    setModalData(item);
                  }}
                  setModalData={() => {
                    setModalData(item);
                  }}
                />
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Box>
  );
};

export default TableReport;
